import { render, staticRenderFns } from "./TodayStats.vue?vue&type=template&id=44207e3a&scoped=true&"
import script from "./TodayStats.vue?vue&type=script&lang=js&"
export * from "./TodayStats.vue?vue&type=script&lang=js&"
import style0 from "./TodayStats.vue?vue&type=style&index=0&id=44207e3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44207e3a",
  null
  
)

export default component.exports